import { useRef } from 'react'
import useIntersectionObserver from 'hooks/useIntersectionObserver'
import { DelayTimes } from 'types/DelayTimes'

export interface AnimatedContainerProps {
  children: React.ReactNode
  animation: string
  delay?: DelayTimes
  extraCssClasses?: string
}

export const useAnimatedContainer = (props: AnimatedContainerProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const isVisible = useIntersectionObserver(ref)

  return {
    ...props,
    ref,
    isVisible,
  }
}
